/*=======================================================================
 * $Id$
*
* Copyright © Mindbreeze Software GmbH, Linz, Austria, 2005-2013
*
* Der Nutzer des Computerprogramms anerkennt, dass der oben stehende
* Copyright-Vermerk im Sinn des Welturheberrechtsabkommens an der vom
* Urheber festgelegten Stelle in der Funktion des Computerprogramms
* angebracht bleibt, um den Vorbehalt des Urheberrechtes genuegend zum
* Ausdruck zu bringen. Dieser Urheberrechtsvermerk darf weder vom Kunden,
* Nutzer und/oder von Dritten entfernt, veraendert oder disloziert werden.
* =========================================================================*/

 define([
     "client/resourceinfo",
     "utils/browser"
   ],
   function (
     ResourceInfo,
     browser
   ) {

  // Loads apptest.js if the url parameter "apptest.fabasoft.com" is set
  if (browser.getURLParameter("apptest.fabasoft.com")) {
    var script = document.createElement("script");
    script.src = ResourceInfo.scriptLocation + "../lib/apptest.js";
    script.type = "text/javascript";
    script.async = true
    script.charset = 'utf-8';

    var s = document.getElementsByTagName('script')[0];
    s.parentNode.insertBefore(script, s);
  }
})
